import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Text } from 'rebass/styled-components'
import styled from 'styled-components'
import SectionHeading from 'components/SectionHeading'
import ContentWrapper from 'components/ContentWrapper'
import CallToAction from 'components/CallToAction'
import Layout from 'components/Layout'

const PostContent = styled(Box)`
  & {
    p,
    span > p,
    li,
    span > li {
      font-size: ${(props) => props.theme.fontSizes[3]}px !important;
      font-family: ${(props) => props.theme.fonts.serif};
      margin: 0 0 ${(props) => props.theme.space[3]}px 0;
      color: ${(props) => props.theme.colors.primary};

      @media (max-width: 32em) {
        font-size: ${(props) => props.theme.fontSizes[3]}px;
      }
    }
    a {
      color: ${(props) => props.theme.colors.gray1};
      &:visited {
        color: ${(props) => props.theme.colors.accent1};
      }
    }
    h3,
    h4,
    h5,
    p,
    li {
      letter-spacing: ${(props) => props.theme.letterSpacing};
    }
    h3 {
      font-family: ${(props) => props.theme.fonts.serif};
      color: ${(props) => props.theme.colors.gray1};
      font-weight: ${(props) => props.theme.fontWeights[0]};
      font-size: ${(props) => props.theme.fontSizes[5]}px;
      @media (max-width: 32em) {
        font-size: ${(props) => props.theme.fontSizes[4]}px;
      }
    }
    h4 {
      text-transform: uppercase;
      font-family: ${(props) => props.theme.fonts.sans};
      font-size: ${(props) => props.theme.fontSizes[4]}px;
      font-weight: ${(props) => props.theme.fontWeights[2]};
      color: ${(props) => props.theme.colors.primary};
      margin-bottom: ${(props) => props.theme.space[1]}px;
      @media (max-width: 32em) {
        font-size: ${(props) => props.theme.fontSizes[3]}px;
      }
    }
    h5 {
      text-transform: uppercase;
      font-size: ${(props) => props.theme.fontSizes[2]}px;
      font-weight: ${(props) => props.theme.fontWeights[3]};
      color: ${(props) => props.theme.colors.primary};
      margin-bottom: ${(props) => props.theme.space[1]}px;
    }

    img {
      margin: ${(props) => props.theme.space[5]}px auto;
      max-width: 100%;
      height: auto;
      display: flex;
      @media (max-width: 32em) {
        margin: ${(props) => props.theme.space[3]}px auto;
      }
    }
    figure {
      max-width: 100%;
      margin: ${(props) => props.theme.space[5]}px auto;
      img {
        margin-bottom: ${(props) => props.theme.space[2]}px;
      }
      ul.blocks-gallery-grid {
        list-style: none;
      }
    }
  }
`

const Excerpt = styled(Text)`
  font-family: ${(props) => props.theme.fonts.sans};
  text-transform: uppercase;
  font-size: ${(props) => props.theme.fontSizes[4]}px;
  color: ${(props) => props.theme.colors.gray1};
  letter-spacing: ${(props) => props.theme.letterSpacing};
  @media (max-width: 32em) {
    font-size: ${(props) => props.theme.fontSizes[1]}px;
  }
`

const NavWrapper = styled(Flex)`
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.accent1};
  }
`

const Arrow = styled(Box)`
  cursor: pointer;
  text-decoration: none;
  font-size: ${(props) => props.theme.fontSizes[5]}px;
`

const NavLink = styled(SectionHeading)`
  margin: 0 !important;
  &:hover,
  ${NavWrapper}:hover & {
    color: ${(props) => props.theme.colors.accent1};
  }
`
function Post ({ currentPost }) {
  return (
    <Layout>
      <ContentWrapper>
        <Box is='article' width={[1, '80%']} mx='auto'>
          <Box p={2}>
            <Excerpt mb={2}>{currentPost.acf.tags_for_excerpt}</Excerpt>
            <SectionHeading>{currentPost.title.rendered}</SectionHeading>
            <PostContent
              className='post-content'
              mx='auto'
              dangerouslySetInnerHTML={{
                __html: currentPost.content.rendered,
              }}
            />
            <NavWrapper
              alignItems='center'
              my={4}
              onClick={() => window.history.back()}
            >
              <Arrow mr={2}>←</Arrow>
              <NavLink fontSize={3}>Back</NavLink>
            </NavWrapper>
          </Box>
        </Box>
      </ContentWrapper>
      {/*<ContentWrapper $accent $noPadding>*/}
      {/*  <CallToAction text={`Ready, Set, Let's Go`} />*/}
      {/*</ContentWrapper>*/}
    </Layout>
  )
}

Post.propTypes = {
  currentPost: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.shape({
      rendered: PropTypes.string.isRequired,
    }),
    content: PropTypes.shape({
      rendered: PropTypes.string.isRequired,
    }),
    isFetched: PropTypes.bool,
    acf: PropTypes.shape({
      tags_for_excerpt: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
      ]),
    }),
  }),
}

export default Post
